import { render, staticRenderFns } from "./SelectExamDropDown.vue?vue&type=template&id=0d20f8a8&scoped=true&"
import script from "./SelectExamDropDown.vue?vue&type=script&lang=js&"
export * from "./SelectExamDropDown.vue?vue&type=script&lang=js&"
import style0 from "./SelectExamDropDown.vue?vue&type=style&index=0&id=0d20f8a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d20f8a8",
  null
  
)

export default component.exports